const mediaItems = [
  {
    title: '韩漫推荐：2024上半年必追TOP10',
    desc: '为你精选本年度上半年最值得一看的韩漫佳作，每部都是口碑爆款。',
    tag: '韩漫推荐',
    views: '12.3万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20review%20video%20thumbnail%20style%20illustration%20with%20warm%20vibrant%20colors%2C%20comic%20panel%20and%20speech%20bubble%20design%20elements%2C%20clean%20cream%20background%2C%20modern%20YouTube%20thumbnail%20aesthetic%2C%20editorial%20quality%2C%20Japanese%20manga%20style&width=600&height=360&seq=media-01&orientation=landscape',
  },
  {
    title: '日漫大全：那些被遗忘的神作',
    desc: '挖掘日漫史上容易被忽略但质量极高的作品，每一部都值得细细品味。',
    tag: '日漫大全',
    views: '9.8万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20review%20video%20thumbnail%20style%20illustration%20with%20warm%20vibrant%20colors%2C%20comic%20panel%20and%20speech%20bubble%20design%20elements%2C%20clean%20cream%20background%2C%20modern%20YouTube%20thumbnail%20aesthetic%2C%20editorial%20quality%2C%20Japanese%20manga%20style&width=600&height=360&seq=media-02&orientation=landscape',
  },
  {
    title: '国漫排行榜：年度作品大盘点',
    desc: '国漫精品逐年增多，这份年度榜单帮你快速锁定最值得阅读的国漫。',
    tag: '国漫排行榜',
    views: '8.6万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20review%20video%20thumbnail%20style%20illustration%20with%20warm%20vibrant%20colors%2C%20comic%20panel%20and%20speech%20bubble%20design%20elements%2C%20clean%20cream%20background%2C%20modern%20YouTube%20thumbnail%20aesthetic%2C%20editorial%20quality%2C%20Japanese%20manga%20style&width=600&height=360&seq=media-03&orientation=landscape',
  },
  {
    title: '漫画分类指南：找到你的本命类型',
    desc: '不同分类的漫画该怎么选？一篇指南带你精准找到最适合自己的漫画类型。',
    tag: '漫画分类',
    views: '7.2万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20review%20video%20thumbnail%20style%20illustration%20with%20warm%20vibrant%20colors%2C%20comic%20panel%20and%20speech%20bubble%20design%20elements%2C%20clean%20cream%20background%2C%20modern%20YouTube%20thumbnail%20aesthetic%2C%20editorial%20quality%2C%20Japanese%20manga%20style&width=600&height=360&seq=media-04&orientation=landscape',
  },
  {
    title: '好看的漫画推荐：入坑必读清单',
    desc: '新手入坑不知道从哪看起？这份入门清单帮你开启精彩的漫画世界。',
    tag: '好看的漫画',
    views: '15.1万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20review%20video%20thumbnail%20style%20illustration%20with%20warm%20vibrant%20colors%2C%20comic%20panel%20and%20speech%20bubble%20design%20elements%2C%20clean%20cream%20background%2C%20modern%20YouTube%20thumbnail%20aesthetic%2C%20editorial%20quality%2C%20Japanese%20manga%20style&width=600&height=360&seq=media-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">漫评推荐</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            精选漫画评析与推荐内容，帮你发现更多<strong>漫画分类</strong>中的宝藏作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.slice(0, 3).map((item) => (
            <div
              key={item.title}
              className="group overflow-hidden rounded-xl border border-background-200/60 bg-background-50 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="relative overflow-hidden h-44 md:h-48">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  title={`${item.title} - 土豪漫画网`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 to-transparent"></div>
                <div className="absolute top-3 left-3 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-accent-600 whitespace-nowrap">
                  <i className="ri-play-circle-fill text-sm"></i>
                  <span>{item.tag}</span>
                </div>
                <div className="absolute bottom-3 right-3 text-xs text-background-50/90 font-medium whitespace-nowrap">
                  <i className="ri-eye-line mr-1"></i>{item.views}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-serif font-semibold text-sm md:text-base text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {mediaItems.slice(3).map((item) => (
            <div
              key={item.title}
              className="group overflow-hidden rounded-xl border border-background-200/60 bg-background-50 hover:border-primary-200/60 transition-all cursor-pointer sm:col-span-2 lg:col-span-1"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="relative overflow-hidden h-40 sm:h-auto sm:w-56 flex-shrink-0">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    title={`${item.title} - 土豪漫画网`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-accent-600 whitespace-nowrap">
                    <i className="ri-play-circle-fill text-sm"></i>
                    <span>{item.tag}</span>
                  </div>
                </div>
                <div className="p-4 flex-1 flex flex-col justify-center">
                  <h3 className="font-serif font-semibold text-sm md:text-base text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">{item.desc}</p>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    <i className="ri-eye-line mr-1"></i>{item.views} 次浏览
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}